import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { TOKEN } from '../keys/key';

@Injectable({ providedIn: 'root' })
export class SocketService {
  constructor(private readonly cookieService: CookieService) {}

  private socket: Socket | undefined;

  private isConnected = new BehaviorSubject<boolean>(false);
  isConnected$ = this.isConnected.asObservable();

  /**
   * @description Connect the socket with the given token
   */
  connectSocket(url: string, headers?: any) {
    const token = this.cookieService.get(TOKEN);

    this.socket = io(url, {
      extraHeaders: {
        authorization: token,
        ...headers,
      },
    });

    this.socket.on('connect', () => {
      this.isConnected.next(true);
    });

    this.socket.on('disconnect', () => {
      this.isConnected.next(false);
    });
  }

  /**
   * @description Disconnect the socket
   */
  disconnectSocket() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  listen(event: string): Observable<any> {
    return new Observable((obs) => {
      if (this.socket)
        this.socket.on(event, (data: any) => {
          obs.next(data);
        });
    });
  }

  /**
   * @description Send the event message to the server
   * @param event Server event name
   * @param data Data to send
   */
  emit(event: string, data: any) {
    this.socket!.emit(event, data);
  }

  private ngOnDestroy(): void {
    this.disconnectSocket();
  }
}
